'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RaisedButton = require('material-ui/RaisedButton');

var _RaisedButton2 = _interopRequireDefault(_RaisedButton);

var _CircularProgress = require('material-ui/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InstitutionForm = function (_React$Component) {
	_inherits(InstitutionForm, _React$Component);

	function InstitutionForm(props) {
		_classCallCheck(this, InstitutionForm);

		var _this = _possibleConstructorReturn(this, (InstitutionForm.__proto__ || Object.getPrototypeOf(InstitutionForm)).call(this, props));

		_this.onNameChange = _this.onNameChange.bind(_this);
		_this.cancel = _this.cancel.bind(_this);
		_this.onClickSubmit = _this.onClickSubmit.bind(_this);
		return _this;
	}

	_createClass(InstitutionForm, [{
		key: 'componentWillMount',
		value: function componentWillMount() {

			var initialState = {
				nameErrorMsg: '',
				institutionErrorMsg: ''
			};

			if (typeof this.props.institution !== 'undefined') {
				initialState.institution = this.props.institution;
			} else {
				initialState.institution = {
					name: ''
				};
			}

			this.setState(initialState);
		}
	}, {
		key: 'onClickSubmit',
		value: function onClickSubmit() {
			this.props.submit(this.state.institution);
		}
	}, {
		key: 'onNameChange',
		value: function onNameChange(event, value) {
			this.setState({
				institution: _extends({}, this.state.institution, {
					name: value
				})
			});
		}
	}, {
		key: 'cancel',
		value: function cancel() {
			this.props.cancel();
		}
	}, {
		key: 'render',
		value: function render() {
			var requestingCreateInstitution = this.props.requestingCreateInstitution;
			var _state = this.state,
			    institution = _state.institution,
			    nameErrorMsg = _state.nameErrorMsg;

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_TextField2.default, {
						hintText: 'Nome',
						floatingLabelText: 'Nome',
						floatingLabelFixed: true,
						onChange: this.onNameChange,
						value: institution.name,
						errorText: nameErrorMsg,
						fullWidth: true
					})
				),
				_react2.default.createElement('br', null),
				_react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(_RaisedButton2.default, { label: 'Cancelar', onClick: this.cancel }),
					_react2.default.createElement(_RaisedButton2.default, {
						primary: true, label: 'Enviar',
						onClick: this.onClickSubmit,
						style: { marginLeft: '1rem' }
					}),
					requestingCreateInstitution && _react2.default.createElement(_CircularProgress2.default, null)
				)
			);
		}
	}]);

	return InstitutionForm;
}(_react2.default.Component);

exports.default = InstitutionForm;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/institution/InstitutionForm.js
// module id = 1313
// module chunks = 0